import { useState } from "react"
import styled from "styled-components"
import { colors } from "utils"

// Bumped from "betaBannerDismissed" so the new "Reports Updated" message
// re-appears for users who had dismissed the previous beta banner.
const STORAGE_KEY = "reportsUpdatedBannerDismissed"

const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M7.1 18.3C6.7134 18.6866 6.0866 18.6866 5.7 18.3C5.3134 17.9134 5.3134 17.2866 5.7 16.9L9.89289 12.7071C10.2834 12.3166 10.2834 11.6834 9.89289 11.2929L5.7 7.1C5.3134 6.7134 5.3134 6.0866 5.7 5.7C6.0866 5.3134 6.7134 5.3134 7.1 5.7L11.2929 9.89289C11.6834 10.2834 12.3166 10.2834 12.7071 9.89289L16.9 5.7C17.2866 5.3134 17.9134 5.3134 18.3 5.7C18.6866 6.0866 18.6866 6.7134 18.3 7.1L14.1071 11.2929C13.7166 11.6834 13.7166 12.3166 14.1071 12.7071L18.3 16.9C18.6866 17.2866 18.6866 17.9134 18.3 18.3C17.9134 18.6866 17.2866 18.6866 16.9 18.3L12.7071 14.1071C12.3166 13.7166 11.6834 13.7166 11.2929 14.1071L7.1 18.3Z"
      fill="#00140B"
    />
  </svg>
)

export const BetaBanner = ({ title, text }) => {
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(STORAGE_KEY) === "true"
  )

  if (dismissed) return null

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, "true")
    setDismissed(true)
  }

  return (
    <Banner>
      <Content>
        <TextGroup>
          {title && <Title>{title}</Title>}
          <Text>{text}</Text>
        </TextGroup>
        <CloseButton onClick={handleDismiss} aria-label="Dismiss banner">
          <CloseIcon />
        </CloseButton>
      </Content>
    </Banner>
  )
}

const Banner = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid ${colors.pink500};
  background: ${colors.pink50};
  box-shadow: 0 1px 3px 0 rgba(14, 26, 49, 0.10), 0 1px 2px 0 rgba(14, 26, 49, 0.06);
  margin-top: 2rem;
  margin-bottom: 2.25rem;
`

const Content = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
`

const TextGroup = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`

const Title = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  line-height: normal;
  color: ${colors.nightlyWoods950};
`

const Text = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  line-height: normal;
  color: ${colors.nightlyWoods500};

  /* Links (e.g. the support email) keep the underline but use the body text
     color instead of the default blue link styling. */
  a {
    color: inherit;
    text-decoration: underline;
  }
`

const CloseButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`
